module.exports = __webpack_public_path__ + "static/media/man-holding-pencil-herdy.a05cb46c.svg";